<template>
  <v-container>
    <v-row justify="center">
      <v-col>
        <v-dialog v-model="trace.show" persistent max-width="800">
          <v-container>
            <v-row>
              <v-col>
                <v-card>
                  <v-text-field
                    label="Search:"
                    clearable
                    v-model="search"
                    @input="searchChange"
                  >
                  </v-text-field>

                  <v-textarea
                    v-if="found"
                    label="Found:"
                    auto-grow
                    disabled
                    :value="JSON.stringify(content, null, 2)"
                  />

                  <br />

                  <v-btn
                    v-for="(button, buttonIndex) in buttons()"
                    :key="buttonIndex"
                    color="grey"
                    text
                    @click="(e) => buttonClick(button, e)"
                  >
                    {{ button.caption }}
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Trace",
  props: ["trace", "input"],
  data() {
    return {
      search: null,
      found: false,
      content: null,
    };
  },
  methods: {
    title() {
      return "Trace";
    },

    buttons() {
      return [{ caption: this.translatedText("okText"), value: "ok" }];
    },

    buttonClick(button) {
      this.$emit("close-trace", { result: button.value });
    },

    searchChange() {
      if (this.input && Object.keys(this.input).length > 0) {
        const find = Object.keys(this.input).find((tag) => tag == this.search);
        if (find) {
          this.content = this.input[find];
          this.found = true;
        } else {
          this.content = null;
          this.found = false;
        }
      }
    },
  },

  updated() {},
};
</script>

<style>
</style>